import SimplePage from "../components/site/SimplePage";

const sections = [
  {
    title: "Transparent Impact",
    text: "Dashboards and reporting keep donors informed about where every rupee goes."
  },
  {
    title: "Community-first Programs",
    text: "Local leaders guide program design so outcomes stay relevant and sustainable."
  },
  {
    title: "Volunteer Network",
    text: "Structured onboarding, training, and support for volunteers across regions."
  }
];

function Features() {
  return (
    <SimplePage
      title="Features"
      lead="The NGO CMS is built to showcase impact, strengthen trust, and mobilize supporters."
      sections={sections}
    />
  );
}

export default Features;
